import Settings from './settings'
import Region from './region'
import Log from './log'

export default [
  { path: '/enterprise/settings', component: Settings, meta: { auth: true } },
  { path: '/enterprise/region', component: Region, meta: { auth: true } },
  { path: '/enterprise/log', component: Log, meta: { auth: true } }
]